import React from 'react'
import { getWapi } from '@core/Areas/KambiClient/helpers/initWapi'

// Ensure Kambi displays the home page. Workaround for an open issue (2021/07/09) whereby the Kambi client
// navigates back to the Bet History page, when we explicitly link to the home page
export const useRouteEnterRedirect = (): void => {
  const enterPathname = React.useRef(window.location.pathname)

  React.useEffect(() => {
    getWapi().then(wapi => {
      wapi.navigateClient(enterPathname.current)
    })
  }, [])
}
